import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Group, Loader, Modal, Stack, Text } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';

import { fieldsQueryKeys } from 'util/queryKeys';
import showToast from 'actions/toastActions';
import { DispatchType } from 'store/dispatch/types';
import { putSamplePlan } from 'store/samplePlans/requests';
import { SamplePlanType } from 'store/samplePlans/types';

type MarkReadyPropsType = {
  samplePlan: SamplePlanType | DispatchType;
  onSubmit: VoidFunction;
  onClose: VoidFunction;
  opened: boolean;
};

export const MarkReady = ({ samplePlan, onSubmit, onClose, opened }: MarkReadyPropsType) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [isLoading, toggleIsLoading] = useState(false);

  const submit = async () => {
    try {
      toggleIsLoading(true);
      putSamplePlan(
        {
          ready_to_sample: true,
        },
        samplePlan.id,
      );
      showToast(t('markedReadySuccessMsg'));
    } catch (error) {
      showToast(t('markedReadyFailureMsg'), 'error');
    } finally {
      queryClient.invalidateQueries({
        queryKey: fieldsQueryKeys.field(samplePlan.field_id),
      });
      toggleIsLoading(false);
    }
    onSubmit();
    onClose();
  };

  return (
    <Modal onClose={onClose} opened={opened} title={t('markReady')} centered>
      <Stack>
        <Text>{t('markReadyMsg')}</Text>
        <Group justify="flex-end">
          {isLoading && <Loader size="sm" />}
          <Button onClick={submit} disabled={isLoading}>
            {t('markReady')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
